










































































































































import {
    Component,
    Prop,
    Vue,
} from 'vue-property-decorator';
import {
    State,
    Mutation,
    namespace,
} from 'vuex-class';

import moment from 'moment';
import axios from 'axios';

import { Observable, Subscription, BehaviorSubject } from 'rxjs';

import UpdateTaskForm from './components/UpdateTaskForm.vue';

/**/
import TestModal from './components/TestModal.vue';


import modalService from '@/core/ModalService.ts';

const statusMap = ['default', 'processing', 'success', 'error'];
const status = ['关闭', '运行中', '已上线', '异常'];

@Component({
    components: {
        UpdateTaskForm,
    },
})
export default class QueryList extends Vue {
    private searchForm: any;

    private searchFormLayout: any = {
        labelCol: {
            span: 5,
        },
        wrapperCol: {
            span: 18,
            offset: 1,
        },
    };

    private expandForm: boolean = false;

    private selectedRowKeys: any[] = [];

    private selectedRows: any[] = [];

    private tableLoading: boolean = false;

    private moment: any = moment;

    private dataSource: any[] = [];

    private visibleCreateModal: boolean = false;

    private updateTaskFormVisible: boolean = false;

    private createForm: any = null;

    private updateRecord: any = {};

    private columns: any[] = [{
            title: '规则名称',
            dataIndex: 'title',
        },
        {
            title: '描述',
            dataIndex: 'description',
        },
        {
            title: '服务调用次数',
            dataIndex: 'callNo',
            sorter: true,
            align: 'right',
            customRender: this.rightRender,
            needTotal: true,
        },
        {
            title: '状态',
            dataIndex: 'status',
            filters: [{
                    text: status[0],
                    value: 0,
                },
                {
                    text: status[1],
                    value: 1,
                },
                {
                    text: status[2],
                    value: 2,
                },
                {
                    text: status[3],
                    value: 3,
                },
            ],
            customRender: this.statusRender,
        },
        {
            title: '上次调度时间',
            dataIndex: 'updatedAt',
            sorter: true,
            customRender: this.updatedAtRender,
        },
        {
            title: '操作',
            customRender: this.opRender,
        },
    ];

    constructor() {
        super();
    }

    get status() {
        return status;
    }

    get statusMap() {
        return statusMap;
    }

    get statuFilters() {
        return [{
                text: status[0],
                value: 0,
            },
            {
                text: status[1],
                value: 1,
            },
            {
                text: status[2],
                value: 2,
            },
            {
                text: status[3],
                value: 3,
            },
        ];
    }

    private handleModalVisible(isVisible: boolean): void {
        this.visibleCreateModal = isVisible;
    }

    private toggleForm(): void {
        this.expandForm = !this.expandForm;
    }

    private handleFormReset(): void {}

    private handleSearch(): void {}

    private handlerTableChange(pagination: any, filter: any, sorter: any): void {

    }

    private testCallback(param: any) {
    }

    private test() {
        /* webpackChunkName: "list.testmodal" */
        /*
        const ComponentClass: any = () => import(  './components/TestModal.vue');
        console.log(typeof ComponentClass);
        const instance = new ComponentClass();
        console.log(instance);
        instance.then((comp: any) => {
            const modalInstance = new comp.default({
                    propsData: {
                        'props': { user: 'admin2' },
                        ...{ user: 'admin2' },
                    },
                }
            );
            modalInstance.$mount();
        });*/

        /*
        // TestModal
        const instance = modalService.show(TestModal , { user: 'admin2' } );
        */
        const instance = modalService.showAsync(import(  './components/TestModal.vue') , { user: 'admin2' } );
        instance.subscribe((res: any) => {
        });
    }

    private handleUpdateModalVisible(visible: boolean, record: any): void {
        this.updateTaskFormVisible = true;
        this.updateRecord = record;
    }

    private handleCreateModalOk() {
        this.createForm.validateFields((err: any, fieldsValue: any) => {
            if (err) {
                return;
            }
            const description = this.createForm.getFieldValue('description');
            axios.post('/saveRule', {
                desc: description,
            }).then((res: any) => {
                this.createForm.resetFields();
                this.visibleCreateModal = false;
                this.loadRuleData();
            });
        });
    }

    private handleUpdateOk() {
        this.loadRuleData();
    }

    private handleCreateModalCancel(): any {
        this.visibleCreateModal = false;
    }

    private handlerSelectChange(arr1: any, arr2: any) {
        this.selectedRows = arr2;
    }

    private handleMenuClick(e: any) {
    }

    private mounted() {
        this.loadRuleData();
    }

    private loadRuleData() {
        this.tableLoading = true;
        axios.get('/rule').then((res) => {
                this.dataSource = res.data;
            })
            .finally(() => {
                this.tableLoading = false;
            });
    }

    private rightRender(text: string) {
        return `${text} 万`;
    }

    private statusRender(text: any, record: any, index: number) {
        return <a-badge status = {
          statusMap[text]
        }
        text = {
            status[text]
        }
        />;
    }

    private updatedAtRender(text: string) {
        return <span> {
            moment(text).format('YYYY-MM-DD HH:mm:ss')
        } </span>;
    }

    private opRender(text: string, record: any, index: number) {
        return <div>
            <a onClick = {
                () => this.handleUpdateModalVisible(true, record)
            } > 配置 </a>
            <a-divider type = 'vertical' />
            <a href = '' > 订阅警报 </a>
            </div>;
    }

}
